__turbopack_context__.v({
  "emergency-number": "lZgh-G_emergency-number",
});
